require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./business-health-savings-accounts-health-savings-investment-options.json") })
        }
      }, "path---business-health-savings-accounts-health-savings-investment-options");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---business-health-savings-accounts-health-savings-investment-options!./.cache/json/business-health-savings-accounts-health-savings-investment-options.json
// module id = 1991
// module chunks = 231608221292675